import {type ClassValue, clsx} from "clsx"
import {twMerge} from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Check if an environment variable value should be considered truthy.
 * Handles common conventions: "true", "1", "yes", "on", "enabled"
 * Case-insensitive and trims whitespace.
 */
export function isTruthy(value: string | boolean | undefined): boolean {
  // If is boolean return value
  if (typeof value === 'boolean') return value;
  // If is undefined return false
  if (!value) return false;
  const normalized = value.toLowerCase().trim();
  return ['true', '1', 'yes', 'on', 'enabled'].includes(normalized);
}
